import ApiClient from '~/services/client';
import { deserialise } from '~/utils/jsonApi/deserialise';
import { getPageInfo } from '~/utils/table';
import initialState from './initialStates/resource';

const resource = 'conversations';

export default {
  namespace: resource,
  state: {
    ...initialState,
    latest: [],
  },
  effects: {
    *fetch({ payload }, { call, put }) {
      const { pageNumber, pageSize, sortField, sortOrder, filters, searchQuery, extraQueries } = payload;
      const response = yield call(ApiClient.conversations.search, {
        pageNumber,
        pageSize,
        sortField,
        sortOrder,
        filters,
        searchQuery,
        extraQueries,
      });
      yield put({
        type: 'readResource',
        payload: response,
      });
    },
    *fetchLatest({ payload }, { call, put }) {
      const { pageNumber, pageSize, sortField, sortOrder, filters, searchQuery } = payload;

      const extraQueries = {
        unread: true,
        ...payload.extraQueries,
      };

      const response = yield call(ApiClient.conversations.search, {
        pageNumber,
        pageSize,
        sortField,
        sortOrder,
        filters,
        searchQuery,
        extraQueries,
      });
      yield put({
        type: 'readLatestResource',
        payload: response,
      });
    },
    *create({ payload }, { call, put }) {
      const { params } = payload;
      const response = yield call(ApiClient.conversations.create, params);
      if (response) {
        const { receiver_id } = params;
        yield put({
          type: 'createResource',
          payload: response,
        });
        yield put({
          type: 'fetch',
          payload: {
            extraQueries: {
              member_id: receiver_id,
            },
          },
        });
      }
    },
    *read({ payload }, { call, put }) {
      const { id } = payload;
      const response = yield call(ApiClient.conversations.read, id);
      yield put({
        type: 'currentResource',
        payload: response,
      });
    },
    *clear(_, { put }) {
      yield put({ type: 'clearResource' });
    },
    *update({ payload }, { call, put }) {
      const { id, params } = payload;
      const response = yield call(ApiClient.conversations.update, id, params);
      if (response) {
        yield put({
          type: 'updateResource',
          payload: response.data,
        });
      }
    },
    *delete({ payload }, { call, put }) {
      const { id } = payload;
      yield call(ApiClient.conversations.delete, id);
      yield put({
        type: 'deleteResource',
        payload: { id },
      });
      yield put({
        type: 'fetch',
        payload: { id },
      });
    },
  },
  reducers: {
    readResource(state, action) {
      const { links } = action.payload;
      const { pageNumber, pageSize, total, sortField, sortOrder, searchQuery } = getPageInfo(links);
      const { data } = deserialise(action.payload);
      return {
        ...state,
        list: data,
        pageNumber,
        pageSize,
        total,
        sortField,
        sortOrder,
        searchQuery,
      };
    },
    readLatestResource(state, action) {
      const { links } = action.payload;
      const { pageNumber, pageSize, total, sortField, sortOrder, searchQuery } = getPageInfo(links);
      const { data } = deserialise(action.payload);
      return {
        ...state,
        latest: data,
        pageNumber,
        pageSize,
        total,
        sortField,
        sortOrder,
        searchQuery,
      };
    },
    createResource(state, action) {
      const { data } = deserialise(action.payload);
      return {
        ...state,
        resource: data,
      };
    },
    updateResource(state) {
      return {
        ...state,
      };
    },
    currentResource(state, action) {
      const { data } = deserialise(action.payload);
      return {
        ...state,
        resource: data,
      };
    },
    deleteResource(state) {
      return {
        ...state,
      };
    },
    clearResource(state) {
      return {
        ...state,
        resource: initialState.resource,
      };
    },
  },
};
